import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/site";
import { SectionEyebrow } from "../SectionEyebrow";

export const Testimonials = () => (
    <section className="py-20 lg:py-28 bg-brand-navy relative overflow-hidden" data-testid="testimonials-section">
        <div className="absolute inset-0 grain-bg opacity-30 pointer-events-none" />
        <div className="container-fe relative">
            <SectionEyebrow className="[&>span:last-child]:text-brand-green">Voces que importan</SectionEyebrow>
            <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight max-w-2xl">
                Las personas que han caminado este proceso.
            </h2>
            <div className="mt-14 grid md:grid-cols-3 gap-6">
                {TESTIMONIALS.map((t) => (
                    <div
                        key={t.author}
                        className="rounded-2xl bg-white/5 backdrop-blur border border-white/10 p-7 hover:bg-white/10 transition-all"
                    >
                        <Quote size={32} className="text-brand-green" />
                        <p className="mt-4 text-white/90 leading-relaxed italic">"{t.quote}"</p>
                        <div className="mt-6 pt-6 border-t border-white/10">
                            <div className="font-display font-semibold text-white">{t.author}</div>
                            <div className="text-xs text-white/60 mt-1">{t.role}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
